/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import {
  DialogFooter,
  // DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { useReactForm } from "../react-hook/use-react-form";
import {
  CountryInput,
  PasswordInput,
  SelectWithSearch,
} from "@/components/form-input";
import { IconRender } from "@/components/shared/Icon-render";
import { CompanyNameInput } from "../user-input/company-name-input";
import { useEffect, useState } from "react";
import { RequiredInput } from "@/components/shared/required-input";
import { useProcess } from "@/global-data";

type UserFormType = {
  formData: any;
  onOpenChange: (prop: any) => void;
  onFormSubmit: (prop: boolean) => Promise<void>;
  open: boolean;
  companyData: any;
  company_id: any;
  roleList: any;
  loadFormRoleList: (prop: string) => Promise<any>;
  loadFormRetailerList: (prop: string) => Promise<any>;
};
export const ReactForm = ({
  formData,
  onOpenChange,
  onFormSubmit,
  open,
  companyData,
  company_id,
  loadFormRoleList,
  loadFormRetailerList,
}: UserFormType) => {
  const { form, onSubmit } = useReactForm({
    formData,
    onOpenChange,
    onFormSubmit,
    open,
    company_id,
  });

  const { setProcess } = useProcess();

  const [formRoleList, setFormRoleList] = useState<any>([]);
  const [formRetailerList, setFormRetailerList] = useState<any>([]);

  const loadCompanyResources = async (prop: any) => {
    setProcess(true);
    const [tempRole, tempRetailer] = await Promise.all([
      loadFormRoleList(prop),
      loadFormRetailerList(prop),
    ]);
    setProcess(false);
    if (tempRole?.data) {
      setFormRoleList(tempRole.data);
    }
    if (tempRetailer?.data) {
      setFormRetailerList(tempRetailer.data);
    }
  };

  useEffect(() => {
    if (company_id !== "system") {
      form.setValue("company_name", company_id, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
      form.setValue("company_id", company_id, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    }
  }, [company_id, form]);

  // useEffect(() => {
  //   if (formData?.company_id) {
  //     loadCompanyResources(formData.company_id);
  //   }
  // }, [formData]);
  useEffect(() => {
    if (company_id !== "system") {
      loadCompanyResources(company_id);
    } else if (formData?.company_id) {
      loadCompanyResources(formData.company_id);
    }
  }, [company_id, formData]);

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="grid md:grid-cols-2 grid-cols-1 gap-x-6 gap-y-5 px-6">
          <FormField
            control={form.control}
            name="username"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  Username
                  <RequiredInput />
                </FormLabel>
                <FormControl>
                  <Input autoComplete="off" placeholder="Username" {...field} />
                </FormControl>

                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="password"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  Password
                  <RequiredInput />
                </FormLabel>
                <FormControl>
                  <PasswordInput placeholder="Password" field={field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="company_id"
            render={({ field }) => (
              <FormItem className="hidden">
                <FormLabel>
                  Company Id
                  <RequiredInput />
                </FormLabel>
                <FormControl>
                  <Input placeholder="Company Id" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="role_id"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  Role
                  <RequiredInput />
                </FormLabel>
                <FormControl>
                  <SelectWithSearch
                    className=" bg-white"
                    bindLabel="role_name"
                    bindValue="role_id"
                    placeholder="Select Role"
                    options={formRoleList}
                    onChange={field.onChange}
                    value={field.value}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="company_name"
            disabled={company_id !== "system"}
            render={({ field }) => {
              return (
                <FormItem className={company_id !== "system" ? "hidden" : ""}>
                  <FormLabel>
                    Company Name
                    <RequiredInput />
                  </FormLabel>
                  <FormControl>
                    <CompanyNameInput
                      placeholder="Select Company Name"
                      value={field.value}
                      onChange={(prop: any) => {
                        field.onChange(prop);
                        loadCompanyResources(prop);
                        console.log("prop", prop);
                      }}
                      companyData={companyData}
                      setValue={form.setValue}
                      disabled={company_id !== "system"}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              );
            }}
          />
          <FormField
            control={form.control}
            name="country"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Country</FormLabel>
                <FormControl>
                  <CountryInput
                    placeholder="Country"
                    value={field.value}
                    onChange={field.onChange}
                    companyData={[]}
                    defaultValue="singapore"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem className="">
                <FormLabel>
                  Email
                  <RequiredInput />
                </FormLabel>
                <FormControl>
                  <Input placeholder="Email" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="phone"
            render={({ field }) => (
              <FormItem className="">
                <FormLabel>Phone number</FormLabel>
                <FormControl>
                  <Input
                    type="number"
                    placeholder="Phone number"
                    value={field?.value ? +field?.value : ""}
                    onChange={(e) => field.onChange(+e.target.value)}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="linked_customer"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Retailer </FormLabel>
                <FormControl>
                  <SelectWithSearch
                    className=" bg-white"
                    bindLabel="retailer_name"
                    bindValue="retailer_id"
                    placeholder="Retailer"
                    options={formRetailerList}
                    onChange={field.onChange}
                    value={field.value}
                    clearable={true}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
        <hr className="mt-5" />
        <DialogFooter className="p-6 flex md:justify-start flex-row justify-between">
          <Button
            type="submit"
            className="w-[120px]"
            disabled={form.formState.isSubmitting}
          >
            {form.formState.isSubmitting ? (
              <IconRender
                name="LoaderCircle"
                className="w-5 animate-spin text-white zoom-in-150"
              />
            ) : (
              "Save"
            )}
          </Button>
          <Button
            type="submit"
            onClick={() => onOpenChange(false)}
            variant={"outline"}
            className="w-[120px]"
          >
            Close
          </Button>
        </DialogFooter>
      </form>
    </Form>
  );
};
